import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=6d4b43fe&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=6d4b43fe&prod&lang=scss&"
import style1 from "./Category.vue?vue&type=style&index=1&id=6d4b43fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports